<template>
	<Teleport to="body">
		<div
			class="fixed top-[calc(var(--tg-safe-area-inset-top,_0px)_+_var(--tg-content-safe-area-inset-top,_0px))] right-0 bottom-0 left-0 z-50 flex flex-col overflow-y-scroll rounded-t-xl pt-16"
			v-bind="$attrs"
			:class="{ 'pointer-events-none': !model }"
		>
			<Transition
				enterActiveClass="transition-opacity duration-500 ease-in-out"
				leaveActiveClass="transition-opacity duration-500 ease-in-out"
				enterFromClass="opacity-0"
				leaveToClass="opacity-0"
			>
				<div
					class="pointer-events-auto fixed inset-0 bg-black/80"
					@click="close()"
					v-if="model"
				/>
			</Transition>
			<Transition
				enterActiveClass="transition-all duration-500 ease-in-out"
				leaveActiveClass="transition-all duration-500 ease-in-out"
				enterFromClass="opacity-0 translate-y-full"
				leaveToClass="opacity-0 translate-y-full"
				@afterEnter="afterEnter()"
				@afterLeave="afterLeave()"
			>
				<div
					class="bg-fill-tertiary pointer-events-auto relative mt-auto flex flex-col rounded-t-xl pt-6"
					:style="{
						paddingBottom: !noPadding
							? `max(var(--padding-bottom), 1rem)`
							: undefined
					}"
					v-if="model"
				>
					<div
						class="relative z-2 mb-4 flex shrink-0 items-start justify-between px-4"
					>
						<slot name="leftAction">
							<div
								class="relative"
								v-hover="{ impact: 'soft' }"
								@click="back()"
								:class="{ 'pointer-events-none opacity-0': !canBack }"
							>
								<ArrowLeftIcon class="text-label-tertiary h-5 w-5" />
								<div class="absolute -inset-2" />
							</div>
						</slot>
						<div
							class="font-squad text-label-primary text-2xl leading-8 font-black uppercase"
						>
							{{ title }}
						</div>
						<div class="relative" v-hover="{ impact: 'soft' }" @click="close()">
							<CloseIcon class="text-label-tertiary h-5 w-5" />
							<div class="absolute -inset-2" />
						</div>
					</div>
					<slot />
				</div>
			</Transition>
		</div>
	</Teleport>
</template>
<script setup lang="ts">
import ArrowLeftIcon from '@/assets/icons/arrow-left.svg'
import CloseIcon from '@/assets/icons/close.svg'

defineProps<{
	canBack?: boolean
	title: string
	noPadding?: boolean
}>()

const emit = defineEmits<{
	(e: 'back'): void
	(e: 'transitionShow', value: boolean): void
	(e: 'close'): void
}>()

const model = defineModel<boolean>()

const close = () => {
	model.value = false
	emit('close')
}

const back = () => {
	emit('back')
}

const afterEnter = () => {
	emit('transitionShow', true)
}

const afterLeave = () => {
	emit('transitionShow', false)
}
</script>
